import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPlane = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<clipPath id="a"><path d="M0 0h32v32H0z" /></clipPath><g clipPath="url(#a)"><path fill="currentColor" d="M31.095.904a3.09 3.09 0 0 0-4.41.045L20.129 7.78 4.132 2.484.774 5.842l13.336 8.21-6.748 7.03-4.327-.71L0 23.408l6.361 2.23 2.23 6.36 3.034-3.035-.71-4.327 7.033-6.748 8.21 13.336 3.357-3.358-5.296-16L31.05 5.31a3.082 3.082 0 0 0 .045-4.407z" /></g></svg>;
export default SvgPlane;